export enum YearPeriod
{
    Monthly = 1,
    TwoMonth = 2,
    ThreeMonth = 3,
    Quarterly = 4,
    FiveMonth = 5,
    Biannual = 6
}